<template>
    <div>
        <div class="bg-dark m-b-30">
            <div class="container">
                <div class="row p-b-60 p-t-60">

                    <div class="col-md-6 text-white p-b-30">
                        <div class="media">
                            <div class="avatar avatar mr-3">
                                <div class="avatar-title bg-success rounded-circle mdi mdi-account-group-outline"></div>
                            </div>
                            <div class="media-body">
                                <h3 class="p-t-10">{{ pageTitle }} </h3>
                                <p class="opacity-75">
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6 text-center m-b-30 ml-auto">
                        <div class="text-md-right">
                            <router-link v-can="'user.read'" :to="{name: 'users'}" class="el-button el-button--primary el-button--medium"><i
                                    class="mdi mdi-format-list-bulleted"></i> {{ $t('user.button.user') }}
                            </router-link>
                            <el-button v-can="'user.create'" type="success" size="medium" @click="displayDialog =  true">
                                <i class="mdi mdi-plus"></i> {{ $t('user.button.create') }}
                            </el-button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <create-edit-user :visible="displayDialog" @created="userCreated" @close="closeUserDialog"></create-edit-user>
        <transition name="slide-fade">
            <router-view @parent-title="updateTitle"/>
        </transition>
    </div>
</template>

<script>
import CreateEditUser from './Modals/CreateEditUser'

export default {
  name: 'User',
  components: { CreateEditUser },
  data () {
    return {
      pageTitle: '',
      displayDialog: false
    }
  },
  methods: {
    closeUserDialog () {
      this.displayDialog = false
    },
    userCreated (data) {
      this.$emit('user-created', data)
    },
    updateTitle (title) {
      this.pageTitle = title
    }
  },
  async mounted () {
    this.$emit('parent-title', this.$t('user.title.user'))
  }
}
</script>

<style scoped>

</style>
